import { render, staticRenderFns } from "./editExamination.vue?vue&type=template&id=b85e7132&scoped=true&"
import script from "./editExamination.vue?vue&type=script&lang=js&"
export * from "./editExamination.vue?vue&type=script&lang=js&"
import style0 from "./editExamination.vue?vue&type=style&index=0&id=b85e7132&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b85e7132",
  null
  
)

export default component.exports